import { useLazyQuery } from '@apollo/client';

import { apolloClientContracts } from '@/apollo/clients/contracts.apollo';
import { notificationService } from '@/services/notification/notification.client';
import GetVarBillingUsageDetailsStatsQuery from
  '@/graphql/contracts/getVarBillingUsageDetailsStats.query.gql';
import { GetVarBillingUsageDetailsStats, GetVarBillingUsageDetailsStatsVariables } from
  '@/graphql/contracts/_generated_/getVarBillingUsageDetailsStats.query';
import { UsageDetailsPayload } from '../../types';

export default function useGetVarBillingUsageDetailsStats() {
  const [_getVarBillingUsageDetailsStats, { loading, error, data }] =
    useLazyQuery<GetVarBillingUsageDetailsStats, GetVarBillingUsageDetailsStatsVariables>(
      GetVarBillingUsageDetailsStatsQuery,
      {
        client: apolloClientContracts,
        fetchPolicy: 'network-only',
        onError: (err) => notificationService.open({
          title: 'Error',
          text: err.message,
          type: 'danger'
        }),
      });

  const getVarBillingUsageDetailsStats = (filter?: UsageDetailsPayload['filter']) => {
    return _getVarBillingUsageDetailsStats({
      variables: {
        filter
      },
    });
  };

  return {
    getVarBillingUsageDetailsStats,
    usageStats: data?.varBillingUsageDetailsTotals,
    isLoadingUsageDetailsStats: loading,
    errorUsageDetailsStats: error,
  } as const;
}
